((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CorkopiaAnalytics = api;
  if (typeof document !== 'undefined') api.init(document);
})(typeof globalThis !== 'undefined' ? globalThis : window, () => {
  'use strict';

  const EVENT_NAME = 'corkopia:analytics';
  const ALLOWED_EVENTS = new Set([
    'home_hero_primary_clicked',
    'home_hero_secondary_clicked',
    'home_family_clicked',
    'home_size_clicked',
    'home_enclosure_clicked',
    'home_use_clicked',
    'home_carousel_impression',
    'home_carousel_navigated',
    'home_product_clicked',
    'home_add_to_box_clicked',
    'home_guided_builder_clicked',
    'home_prebuilt_clicked',
    'home_inspiration_clicked',
    'home_form_explored',
    'home_story_step',
    'home_quickstart_clicked',
    'product_card_hovered',
    'product_quick_view_opened',
    'product_add_to_box',
    'product_full_details_opened',
    'smart_box_item_removed',
    'smart_box_expanded',
    'smart_box_collapsed',
    'smart_box_checkout_started',
    'collection_viewed',
    'collection_filter_used',
    'standard_search_submitted',
    'natural_search_submitted',
    'product_viewed',
    'box_size_changed',
    'build_started',
    'build_accepted',
    'product_added_to_cart',
    'prebuilt_box_added',
    'empty_state_interacted',
    'save_interest',
    'checkout_initiated'
  ]);

  const cleanDetail = (detail = {}) => Object.fromEntries(
    Object.entries(detail)
      .filter(([, value]) => ['string', 'number', 'boolean'].includes(typeof value))
      .map(([key, value]) => [key, typeof value === 'string' ? value.slice(0, 160) : value])
  );

  const emit = (name, detail = {}, documentRef = document) => {
    if (!ALLOWED_EVENTS.has(name) || !documentRef?.dispatchEvent) return false;
    const eventDetail = {
      event: name,
      schemaVersion: '1.0.0',
      ...cleanDetail(detail)
    };
    const EventConstructor = documentRef.defaultView?.CustomEvent || globalThis.CustomEvent;
    const analyticsEvent = EventConstructor
      ? new EventConstructor(EVENT_NAME, { detail: eventDetail })
      : { type: EVENT_NAME, detail: eventDetail };
    documentRef.dispatchEvent(analyticsEvent);
    return true;
  };

  const init = (documentRef) => {
    documentRef.addEventListener('click', (event) => {
      const target = event.target.closest?.('[data-corkopia-event]');
      if (target) {
        emit(target.dataset.corkopiaEvent, {
          label: target.dataset.corkopiaLabel || target.textContent.trim(),
          destination: target.getAttribute('href') || '',
          section: target.closest('[data-home-section]')?.dataset.homeSection || ''
        }, documentRef);
        return;
      }
      const homepage = event.target.closest?.('[data-home-section]');
      if (!homepage) return;
      const productLink = event.target.closest?.('[data-cork-product-link]');
      const addButton = event.target.closest?.('[data-cork-add]');
      if (productLink) {
        emit(homepage.dataset.homeSection === 'prebuilt_boxes' ? 'home_prebuilt_clicked' : 'home_product_clicked', {
          label: productLink.textContent.trim(),
          destination: productLink.getAttribute('href') || '',
          section: homepage.dataset.homeSection || ''
        }, documentRef);
      } else if (addButton) {
        emit('home_add_to_box_clicked', {
          label: addButton.dataset.pieceId || addButton.dataset.productTitle || '',
          section: homepage.dataset.homeSection || ''
        }, documentRef);
      }
    });
  };

  return { ALLOWED_EVENTS, EVENT_NAME, cleanDetail, emit, init };
});
